import { ChatRow } from 'components/chats/ChatRow'
import { OdinListEmpty } from '@/components/ui/odin/odin-list-empty'
import { ChatBubbleSparklesSvg } from 'components/ui/svg/ChatBubbleSparklesSvg'
import { useSelector } from 'react-redux'
import { settingsSelectors } from 'store/settings'
import { messagesSelectors } from 'store/messages'
import { useTranslation } from 'react-i18next'
import { useMemo, useState } from 'react'
import { isEmpty, size } from 'lodash'
import { sortChatsByLastMessage } from 'utils/chats'
import { OdinButton } from '@/components/ui/odin/odin-button'
import { useModal } from 'providers/ModalProvider'
import { OpenChatModal } from 'components/modals/OpenChatModal'
import { openNewChat } from 'api/chats'
import { useGetAreas } from 'api/areas'
import { useUserChatListSocket } from 'hooks/useUserChatListSocket'

export const ChatsList = () => {
  const { t } = useTranslation()
  const { openModal } = useModal()
  const chatsMap = useSelector(messagesSelectors.chats)
  const currentUserId = useSelector(settingsSelectors.userId)
  const areaId = useSelector(settingsSelectors.areaId)
  const isMultiArea = useSelector(settingsSelectors.isMultiAreaFlow)
  const { data: areas } = useGetAreas()
  const [loading, setLoading] = useState(false)
  const sortedChats = useMemo(() => sortChatsByLastMessage(chatsMap), [chatsMap])

  useUserChatListSocket(currentUserId ? String(currentUserId) : undefined)

  const openChatWithCurrentAreaId = async (areaId: string) => {
    try {
      setLoading(true)
      await openNewChat({ areaId })
    } finally {
      setLoading(false)
    }
  }

  const onClickOpenChat = async () => {
    if (isMultiArea) {
      try {
        setLoading(true)
        await openNewChat({})
      } finally {
        setLoading(false)
      }
      return
    }
    if (areaId) {
      return await openChatWithCurrentAreaId(areaId)
    }
    if (size(areas) === 1) {
      const firstArea = areas[0]
      return await openChatWithCurrentAreaId(firstArea._id)
    }
    openModal(<OpenChatModal />)
  }

  return (
    <>
      <div className="scrollbar-hidden w-full grow self-start overflow-y-auto p-2">
        {isEmpty(sortedChats) && (
          <OdinListEmpty image={<ChatBubbleSparklesSvg />} title={t('emptyChats')} description={t('emptyChatsHint')} />
        )}
        {sortedChats.map((chat) => (
          <ChatRow chat={chat} key={chat._id} />
        ))}
      </div>
      <div className="mt-1 mb-4 w-full px-3">
        <OdinButton loading={loading} className={'w-full'} onClick={onClickOpenChat}>
          {t('openNewChat')}
        </OdinButton>
      </div>
    </>
  )
}
